import { render, staticRenderFns } from "./video-box.vue?vue&type=template&id=d22f10e8&scoped=true&"
import script from "./video-box.vue?vue&type=script&lang=js&"
export * from "./video-box.vue?vue&type=script&lang=js&"
import style0 from "./video-box.vue?vue&type=style&index=0&id=d22f10e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22f10e8",
  null
  
)

export default component.exports